import(/* webpackMode: "eager" */ "/app/app/page.js")